import AlertManagementReducer from './AlertManagement.Reducer';

export default AlertManagementReducer;

